export default Object.freeze({
  PENDING: 'Pending',
  SPOKEN: 'Spoken',
  ACTIVE: 'Active',
  WITHDRAWN: 'Withdrawn'
})



// WEBPACK FOOTER //
// ./src/enums/speaker-state.js